import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '../../../../../node_modules/@angular/common';

@Pipe({
  name: 'dateFormatPipe'
})
export class SemDateFormatPipePipe extends DatePipe implements PipeTransform {

  transform(value: any, format: string): any {
    return super.transform(value, format);
  }

}
